const EntityType = Object.freeze({
  ACTIVITY: 'ACTIVITY',
  ACTIVITY_PROPERTY: 'ACTIVITY_PROPERTY',
  ACTIVITY_PROPERTY_VALUE: 'ACTIVITY_PROPERTY_VALUE',
  ACTIVITY_TAG: 'ACTIVITY_TAG',
  ACTIVITY_TAG_CATEGORY: 'ACTIVITY_TAG_CATEGORY',
  ACTIVITY_TYPE: 'ACTIVITY_TYPE',
  DESIGN: 'DESIGN',
  GROUP: 'GROUP',
  GROUP_PROPERTY: 'GROUP_PROPERTY',
  GROUP_PROPERTY_VALUE: 'GROUP_PROPERTY_VALUE',
  GROUP_TAG: 'GROUP_TAG',
  GROUP_TAG_CATEGORY: 'GROUP_TAG_CATEGORY',
  HISTORICAL: 'HISTORICAL',
  LAYER: 'LAYER',
  L1_PROCESS: 'L1_PROCESS',
  LEAD: 'LEAD',
  LIBRARY: 'LIBRARY',
  LIBRARY_ACTIVITY: 'LIBRARY_ACTIVITY',
  LIVE: 'LIVE',
  MANAGER: 'MANAGER',
  MATRIX: 'MATRIX',
  ORGANISATION: 'ORGANISATION',
  ROLE: 'ROLE',
  ROLE_PROPERTY: 'ROLE_PROPERTY',
  ROLE_PROPERTY_VALUE: 'ROLE_PROPERTY_VALUE',
  ROLE_SKILL: 'ROLE_SKILL',
  ROLE_SKILL_LEVEL: 'ROLE_SKILL_LEVEL',
  ROLE_TAG: 'ROLE_TAG',
  ROLE_TAG_CATEGORY: 'ROLE_TAG_CATEGORY',
  ROLE_TYPE: 'ROLE_TYPE',
  SCENARIO: 'SCENARIO',
  SKILL: 'SKILL',
  SKILL_LEVEL: 'SKILL_LEVEL',
  SPAN: 'SPAN',
  TAG: 'TAG',
  TAG_CATEGORY: 'TAG_CATEGORY',
  PERSON: 'PERSON',
  PERSON_SKILL: 'PERSON_SKILL',
  PERSON_SKILL_LEVEL: 'PERSON_SKILL_LEVEL',
  PROCESS: 'PROCESS',
  PROPERTY: 'PROPERTY',
  PROPERTY_VALUE: 'PROPERTY_VALUE',
  SUPPORTER: 'SUPPORTER',
  UNASSIGNED: 'UNASSIGNED',
  UNTAGGED: 'UNTAGGED',
});

export default EntityType;
